import { render } from "./ResumePage.vue?vue&type=template&id=de90f56c&scoped=true"
const script = {}

import "./ResumePage.vue?vue&type=style&index=0&id=de90f56c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de90f56c"]])

export default __exports__